export const ARCHIVED = "Archived";
export const NEW_OR_READ = "NewOrRead";
